module.exports = {
  "wrapper": {
    "zIndex": 999
  },
  "g-cover": {
    "position": "fixed",
    "top": 0,
    "right": 0,
    "left": 0,
    "bottom": 0,
    "zIndex": 1
  },
  "g-popover": {
    "position": "fixed",
    "paddingTop": "15",
    "paddingRight": "15",
    "paddingBottom": "15",
    "paddingLeft": "15",
    "zIndex": 10
  },
  "u-popover-arrow": {
    "position": "absolute",
    "width": "36",
    "height": "36",
    "backgroundColor": "#ffffff",
    "transform": "rotateZ(45deg)"
  },
  "u-popover-inner": {
    "borderRadius": "16",
    "backgroundColor": "#ffffff",
    "maxWidth": "686"
  },
  "content-inner": {
    "borderRadius": "16",
    "maxWidth": "686",
    "paddingTop": "24",
    "paddingRight": "24",
    "paddingBottom": "24",
    "paddingLeft": "24",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "closeBox": {
    "paddingTop": "10",
    "paddingBottom": "10",
    "paddingRight": "0",
    "paddingLeft": "10"
  },
  "closeIcon": {
    "width": "18",
    "height": "18"
  },
  "u-popover-theme-white": {
    "backgroundColor": "#ffffff"
  },
  "u-popover-theme-dark": {
    "backgroundColor": "#1E2E37"
  },
  "i-btn": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "row-layout": {
    "paddingLeft": "36",
    "paddingRight": "36"
  },
  "column-layout": {
    "paddingTop": "2",
    "paddingBottom": "2"
  },
  "borderRight": {
    "borderRightWidth": "1",
    "borderRightColor": "#eaeaeb"
  },
  "borderBottom": {
    "borderBottomWidth": "1",
    "borderBottomColor": "#eaeaeb"
  },
  "i-btn-noborder": {
    "borderBottomColor": "#ffffff"
  },
  "btn-icon": {
    "width": "32",
    "height": "32",
    "marginRight": "16"
  },
  "btn-text": {
    "flex": 1,
    "height": "96",
    "fontSize": "28",
    "lineHeight": "96",
    "color": "#232323",
    "marginLeft": "8"
  },
  "btn-text-theme-dark": {
    "color": "#ffffff"
  },
  "text-align-center": {
    "textAlign": "center"
  },
  "textContent": {
    "flex": 1,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "24",
    "color": "#616C73",
    "fontWeight": "400"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-4e9a4386!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-popover2/index.vue
// module id = 474
// module chunks = 0 1